import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { useDispatch } from 'hooks/utils';
import { ActionTypes, exportMainDataset, exportSeries } from 'store/data/entries';

type ExportMainDatasetInput = Parameters<typeof exportMainDataset>[0];
type ExportSeriesInput = Parameters<typeof exportSeries>[0];

export function useExportMainDataset(): Operation<(input: ExportMainDatasetInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.EXPORT_MAIN_DATASET);

	function handler(input: ExportMainDatasetInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(exportMainDataset(input));
	}

	return [{ loading, error }, handler];
}

export function useExportSeries(): Operation<(input: ExportSeriesInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.EXPORT_SERIES);

	function handler(input: ExportSeriesInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(exportSeries(input));
	}

	return [{ loading, error }, handler];
}
